export enum PlateMode {
  POSITION_EXIST = 'POSITION_EXIST',
  DNA_WATER = 'DNA_WATER',
  PIP_STATUS = 'PIP_STATUS',
  RESULT = 'RESULT',
  STATUS = 'STATUS',
  MEASURED = 'MEASURED'
}
